import {useDispatch} from "@wordpress/data";
const {cartStore} = window.wc.wcBlocksData;

export default function CartItem({item}) {

	const {removeItemFromCart} = useDispatch(cartStore);

	const removeFromCart = (key) => {
		removeItemFromCart(key);
	};

	function decodeHTMLEntities(text) {
		var textArea = document.createElement('textarea');
		textArea.innerHTML = text;
		return textArea.value;
	}

	// Calculate pricing.
	let regular_total = item.prices.regular_price * item.quantity;
	let on_sale = parseInt(regular_total) !== parseInt(item.totals.line_subtotal);

	return (
		<div className="zapc-checkout-order-summary-table-item">
			<div className="zapc-checkout-order-summary-table-item-actions">
				<button type="button" onClick={(event) => {
					event.preventDefault();
					removeFromCart(item.key)
				}}>
					<i className="fa fa-trash"></i>
				</button>
			</div>
			<div className="zapc-checkout-order-summary-table-item-thumbnail">
				{ item.images.length > 0 && ( <img src={item.images[0].thumbnail} alt=""/> ) }
			</div>
			<div className="zapc-checkout-order-summary-table-item-details">
				<h4 className="zapc-checkout-order-summary-table-item-details-title">
					<a href={item.permalink}>{decodeHTMLEntities(item.name)}</a>
				</h4>
				<ul className="zapc-checkout-order-summary-table-item-details-meta">
					{item.item_data.map((item_data) => (
						<li key={item_data.key}>{item_data.key}: {item_data.display}</li>
					))}
				</ul>
			</div>
			<div className="zapc-checkout-order-summary-table-item-price">
				{ on_sale && ( <div className="price sale-price"><span className="strikethrough">{item.prices.currency_prefix + (item.prices.regular_price / 100).toFixed(2)}</span></div>) }
				<div className="price">{ item.prices.currency_prefix + (item.prices.price / 100).toFixed(2) }</div>
			</div>
			<div className="zapc-checkout-order-summary-table-item-qty">
				{item.quantity}
			</div>
		</div>
	);
}